import { Form as FormikForm } from "formik";
import styled from "styled-components";

export const Form = styled(FormikForm)`
  align-items: start;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;
